import { Component, EventEmitter, Input, Output } from '@angular/core';

export type MediaSlotMode = 'image' | 'video' | 'placeholder';
export type MediaSlotSize = 'large' | 'small';

@Component({
  selector: 'media-slot',
  templateUrl: './media-slot.component.html',
  styleUrls: ['./media-slot.component.scss'],
})
export class MediaSlotComponent {
  /** Image src (gallery hero, or activeMedia image). Required when mode === 'image'. */
  @Input() src: string | null = null;
  /** Which visual state to render. */
  @Input() mode: MediaSlotMode = 'image';
  /** Aspect ratio: 'large' = 323.5px tall, 'small' = 159.5px tall. */
  @Input() size: MediaSlotSize = 'small';
  /** Aria label for the clickable container. */
  @Input() ariaLabel: string = 'Abrir media';
  /** Emits when the user clicks the slot. Parent decides what to do (open lightbox, etc.). */
  @Output() open = new EventEmitter<void>();
  /** Override height with a custom pixel value. Falls back to size-based default when null. */
  @Input() customHeight: number | null = null;

  get height(): string {
    if (this.customHeight !== null) {
      return `${this.customHeight}px`;
    }
    return this.size === 'large' ? '323.5px' : '159.5px';
  }

  onClick(): void {
    this.open.emit();
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.open.emit();
    }
  }
}
